import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-4">
      <button className="w-full py-6 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-5">
        <span className="text-lg font-bold text-navy pr-4" data-id="element-6">{question}</span>
        <ChevronDownIcon className={`w-6 h-6 text-gold transform transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-7" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-8">
        <p className="text-text-muted text-lg leading-relaxed" data-id="element-9">{answer}</p>
      </div>
    </div>;
}
export function FAQSection() {
  const faqs = [{
    question: '¿Necesito tener papeles para esto?',
    answer: 'No, puedes construir un crédito excelente usando únicamente tu número de ITIN.'
  }, {
    question: '¿Cuánto tengo que gastar?',
    answer: 'Puedes empezar con tan solo $200 para una tarjeta asegurada que te devolverán después.'
  }, {
    question: '¿Tengo que saber inglés?',
    answer: 'No, la guía y los bancos recomendados tienen atención en español.'
  }, {
    question: '¿Tardará años?',
    answer: 'No, si sigues el plan, puedes tener un puntaje de 700+ en 6 a 8 meses partiendo de cero absoluto.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-12 text-center" data-id="element-12">
          Preguntas Frecuentes
        </h2>

        <div className="bg-gray-light rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-13">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-14" />)}
        </div>
      </div>
    </section>;
}